import React from "react";
import reactCSS from "reactcss";
import { BlockPicker } from "react-color";
import { Badge } from "reactstrap";

class ColorPickerCustom extends React.Component {
  componentDidMount() {
    if (typeof this.props.color !== "undefined" && this.props.color) {
      try {
        const parsed =
          typeof this.props.color === "string"
            ? JSON.parse(this.props.color)
            : this.props.color;
        if (parsed && typeof parsed === "object") {
          this.setState({ color: parsed });
        }
      } catch (e) {
        // ribbon_color may be a hex string from the API
      }
    }
  }

  state = {
    displayColorPicker: false,
    color: {
      r: "241",
      g: "112",
      b: "19",
      a: "1",
    },
    colorHex: "",
  };

  handleClick = (e) => {
    e.stopPropagation();
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.setState({ displayColorPicker: false });
  };

  handlePickerMouseDown = (e) => {
    e.stopPropagation();
  };

  handleChange = (color) => {
    this.setState({ color: color.rgb, colorHex: color.hex });
  };

  render() {
    const styles = reactCSS({
      default: {
        wrapper: {
          position: "relative",
          display: "inline-block",
        },
        popover: {
          position: "absolute",
          zIndex: 1001,
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
        picker: {
          position: "relative",
          zIndex: 1,
        },
      },
    });

    return (
      <div style={styles.wrapper}>
        <Badge pill onClick={this.handleClick} className="badge-sd">
          <span>{this.props.text}</span>
          <input
            type="hidden"
            value={JSON.stringify(this.state.color)}
            name={this.props.colorFormName}
          />
        </Badge>

        {this.state.displayColorPicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <div style={styles.picker} onMouseDown={this.handlePickerMouseDown}>
              <BlockPicker
                color={this.state.color}
                onChange={this.handleChange}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ColorPickerCustom;
